export * from "./gameActions";
export * from "./uiActions";

export const NEW_HAND = "new_hand";
export const HOLD_CARD = "hold card";
export const DEAL_NEXT_CARDS = "deal next";
export const SET_BET_AMOUNT = "set bet amount";
export const UPDATE_PROBABILITIES = "update probabilities";
export const CALCULATING_PROBABILITIES = "calculating probabilities";

export const ADD_CREDIT = "add credits";
export const SUBTRACT_CREDIT = "subtract credits";

export const GAME_OVER = "game over";
export const RESTART_GAME = "restart game";

export const UI_CARD_IMAGE_LOADED = "card image loaded";
export const UI_CARD_REVEAL = "card reveal";
export const UI_CARD_RESET = "card reset visibility";
